import createCache from '@emotion/cache';

const muiCache = createCache({
    key: 'ca', // Prefix for class names
    prepend: true,
});

export default muiCache;
